import React from 'react';
import { connect } from 'react-redux';

import * as PostActions from "../../data/posts/PostActions";

import PostScheduleModal from './PostScheduleModal';

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = {
    schedulePost: PostActions.schedulePost
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PostScheduleModal);
